import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import React from "react";
import { logError } from "@/utils/logError";
import ErrorPage from "./ErrorPage";

interface State {
  hasError: boolean;
}

class ErrorBoundaryInner extends React.Component<
  { children: React.ReactNode; message: string },
  State
> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    logError(error, { componentStack: info.componentStack ?? undefined });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage message={this.props.message} />;
    }
    return this.props.children;
  }
}

export default function ErrorBoundary({ children }: { children: React.ReactNode }) {
  const { _ } = useLingui();
  return (
    <ErrorBoundaryInner message={_(msg`An unexpected error occurred. Please reload the page.`)}>
      {children}
    </ErrorBoundaryInner>
  );
}
